import type { HighlightedSeriesId } from '../../core/components/interactions-state-helpers/types.js';
import type { XYChartSeriesWithDatapoints } from '../types/xy-chart-internals.js';

export const getHighlightedSeries = (
  seriesWithDatapoints: XYChartSeriesWithDatapoints[],
  highlightedSeriesId: HighlightedSeriesId,
) => {
  return seriesWithDatapoints.find((s) => {
    if (s.type !== 'rect') {
      return highlightedSeriesId === s.id;
    }

    // This includes can cause edge case if by any chance there is series id with name that includes another series id, but with current shape of RectDisplay
    // we cant use comparison there, bc retrieving series data value (category) from this component is causing huge performance issue.
    return highlightedSeriesId?.includes(s.id);
  });
};
